// extracted by mini-css-extract-plugin
module.exports = {"listbox":"notesListWrapper_listbox__H-CWY"};